import React from 'react';

import { designSystemTokens, Typography } from '../../../DesignSystem';

import { StyledSearchSectionTitle } from './styles';

export function SearchSectionTitle({ children }: { children?: React.ReactNode }) {
    return (
        <StyledSearchSectionTitle>
            <Typography
                type="label"
                size={12}
                weight="700"
                variant="span"
                color={designSystemTokens.shades.primary.light[50]}
            >
                {children}
            </Typography>
        </StyledSearchSectionTitle>
    );
}
